import { guardedFetch as publicGuardedFetch } from "../public/lib/api/utils";
import { getPersistedJwt, handleError, type ErrorHandlingOptions } from "../helpers/api/utils";

type ContentType = {
  "Content-Type"?: string;
};

export const FetchUtils = {
  authenticatedFetch: async (
    input: RequestInfo | URL,
    init?: RequestInit,
    jwt?: string,
    contentType: ContentType = { "Content-Type": "application/json" },
    errorHandlingOptions: ErrorHandlingOptions = {}
  ) => {
    const bearer = `Bearer ${jwt ? jwt : getPersistedJwt()}`;
    const authedInit = {
      ...init,
      headers: {
        ...contentType,
        ...init?.headers,
        Authorization: bearer
      }
    };
    return FetchUtils.guardedFetch(input, authedInit, errorHandlingOptions);
  },
  guardedFetch: async (
    input: RequestInfo | URL,
    init?: RequestInit,
    errorHandlingOptions: ErrorHandlingOptions = {}
  ) => {
    try {
      return await publicGuardedFetch(input, init);
    } catch (error) {
      return handleError(error, errorHandlingOptions);
    }
  }
};

export const authenticatedFetch = FetchUtils.authenticatedFetch;
export const guardedFetch = FetchUtils.guardedFetch;

